import type { NestedRecord } from '@core/types/utility.types';

/**
 * Determines if the provided value is a nested record.
 *
 * @param {unknown} value - The value to check.
 * @returns {boolean} Returns true if the value is a nested record, otherwise false.
 */
export function isNestedRecord(value: unknown): value is NestedRecord {
  return typeof value === 'object' && value !== null;
}

/**
 * Resolves a translation string from a nested record structure based on a given path.
 *
 * @param {NestedRecord} translations - A deeply nested record object containing translation strings.
 * @param {string[]} path - An array of strings representing the path to the desired translation key.
 * @returns {string} The resolved translation string if found, or the joined path as a fallback.
 */
export function resolveTranslation(translations: NestedRecord, path: string[]): string {
  let value: NestedRecord | string = translations;

  for (const segment of path) {
    if (isNestedRecord(value)) {
      value = value[segment];
    }
  }

  return typeof value === 'string' ? value : path.join('.');
}
